<template>
  <div class="newxq" v-if="contentData">
    <div class="newtit animation srcospcur">
      <h3 class="ft24">{{contentData.title}}</h3>
      <p>{{contentData.addDate.split(" ")[0]}}</p>
    </div>
    <div class="nexqco animation srcospcur" v-html="contentData.content"></div>
    <div class="newpage animation srcospcur">
      <div class="li">
        <font>上一篇：</font>
        <span v-if="!prevNews">没有了</span>
        <router-link
          v-else
          :to="{name:$route.name,params:{pId:$route.params.pId,cId:$route.params.cId},query:{id:prevNews.id}}"
        >{{prevNews.listTitle}}</router-link>
      </div>
      <div class="li">
        <font>下一篇：</font>
        <span v-if="!nextNews">没有了</span>
        <router-link
          v-else
          :to="{name:$route.name,params:{pId:$route.params.pId,cId:$route.params.cId},query:{id:nextNews.id}}"
        >{{nextNews.listTitle}}</router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { getNewsDetail, getNewsList } from "@/api/index";
export default {
  data() {
    return {
      contentData: null,
      prevNews: null,
      nextNews: null
    };
  },
  created() {
    getNewsDetail({
      contentId: this.$route.query.id
    }).then(res => {
      if (res.data.code == 1000) {
        this.$set(this.$data, "contentData", res.data.data);
        this.getNewsListFun({
          pageNo: 0,
          pageSize: 999,
          condition: {
            nodeId: ""
          }
        });
      }
    });
  },
  methods: {
    // 获取二级列表内容
    getNewsListFun(json) {
      getNewsList(json).then(res => {
        if (res.data.code == 1000) {
          let arr = res.data.data.data;
          arr.forEach((item, index) => {
            if (item.id == this.$route.query.id) {
              if (index > 0) {
                this.prevNews = arr[index - 1];
              } else {
                this.prevNews = null;
              }
              if (index < arr.length - 1) {
                this.nextNews = arr[index + 1];
              } else {
                this.nextNews = null;
              }
            }
          });
          this.$set(this.$data, "allList", res.data.data.data);
        }
      });
    }
  }
};
</script>